import { TextStyle, ViewStyle } from 'react-native';
import Theme from 'Theme';

const container: ViewStyle = {
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 9999,
    backgroundColor: 'rgba(0,0,0,0.75)'
};
const header: { iconContainer: ViewStyle } = {
    iconContainer: {
        position: 'absolute',
        right: 0,
        top: 0
    }
};
const main: ViewStyle = {
    flex: 0.3,
    borderColor: '#fff',
    borderWidth: 1,
    borderRadius: 5,
    padding: 30,
    backgroundColor: '#000'
};
const title: TextStyle = {
    fontSize: 22,
    fontWeight: 700,
    color: '#fff',
    fontFamily: Theme.regularFont,
    marginBottom: 10
};
const hr: ViewStyle = { marginBottom: 20 };
const list: ViewStyle = { flexGrow: 0 };
const contentList: ViewStyle = { gap: 20 };
const button: ViewStyle = { alignItems: 'center', flexDirection: 'row', gap: 20 };
const buttonLabelContainer: ViewStyle = { flex: 1 };
const buttonLabel: TextStyle = {
    fontSize: 24,
    color: Theme.primaryTextColor,
    fontFamily: Theme.regularFont
};
const icon: ViewStyle = {
    width: 30,
    height: 30,
    // marginRight: 35,
    marginLeft: 0,
    justifyContent: 'center'
};
export default {
    container,
    header,
    main,
    title,
    hr,
    list,
    contentList,
    button,
    buttonLabelContainer,
    buttonLabel,
    icon
};
